let env = process.env.VUE_APP_CURRENTMODE
let config = {
  //旧地址
  // 'test': 'http://test.beidouutrail.com/api',
  // 'test': 'https://www.beidouutrail.com/api',
  //新地址
  // 'test': 'https://test-api.beidouutrail.com/api',
  'test': 'https://api.beidouutrail.com/api',
}
let server = {
  'serverurl': config.test,
  /*阿里图片地址*/
  // 'aliurl': 'https://oss-jgwl.cmfun.cn/',
  'aliurl': 'https://utrail-oss.oss-cn-beijing.aliyuncs.com/',
  /*我的*/
  'getuserurl': '/wechat-service/personalCenter/getWechatInfoByCode',//根据Code获取userInfo
  'mymatchurl': '/wechat-service/personalCenter/getMyMatchByOpenID',//根据openID获取我的赛事列表
  'userrealinfourl': '/wechat-service/personalCenter/getWeChatInfoByOpenID',//根据openID获取获取个人信息
  'updateuserinfourl': '/wechat-service/personalCenter/submitWeChatRealInfo',//上传微信用户真实信息
  /*赛事直播*/
  'matchlisturl': '/wechat-service/matchLive/getMatchList',//获取赛事列表
  'grouplisturl': '/wechat-service/matchLive/getMatchGroupList',//获取赛事组别列表
  'grouplistallurl': '/wechat-service/workerCenter/groupListInfo',//获取赛事组别列表(含工作组)
  'locationallurl': '/wechat-service/workerCenter/personLocationList',//获取人员定位和报警(含工作组)
  'routerurl': '/wechat-service/matchLive/getMatchLineInfo',//获取赛事赛道信息
  'playerurl': '/wechat-service/matchLive/getPlayersPositions',//获取赛事赛道选手定位
  'rankurl': '/wechat-service/matchLive/getPlayerRankTop3',//获取赛事赛道前三名选手
  'searchplayerurl': '/wechat-service/matchLive/searchPlayer',//通过选手姓名或参赛号模糊搜索选手
  'checkinfourl': '/wechat-service/matchLive/checkMatchExplain',//判断赛事介绍是否有数据（暂不用）
  'matchinfourl': '/wechat-service/matchLive/getMatchExplain',//获取赛事介绍
  'playerdetailcoors': '/wechat-service/matchLive/getPlayerLocationListByPlayerID',//获取个人选手定位轨迹
  'playerrank': '/wechat-service/matchLive/getPlayerRankByPlayer',//获取个人选手排名
  'cpserver': '/wechat-service/matchLive/getKeyPointServer',//获取打卡点服务类型
  'servertime': '/wechat-service/matchLive/getServerTime',//获取服务器时间
  'serchcode': '/wechat-service/matchLive/getPlayerByMatchCode',// 根据选手参赛号搜索选手
  'searchlive': '/wechat-service/matchLive/getRealTimeLocationByPlayerId',//通过选手ID查询选手实时位置
  // real
  'reallive': '/wechat-service/matchLive/getPlayerRealTimeData',// 选手位置实时经纬度速度等
  'realroute': '/wechat-service/matchLive/getRouteByMatchGroupId',//
  'realreset': '/wechat-service/matchLive/resetPlayerData',//
  //new
  'matchmenuget': '/wechat-service/matchLive/getMatchMenuByMatchID',//获取赛事信息
  'matchtrackviewget': '/wechat-service/matchLive/getMatchTrackView',//获取赛事赛道信息
  //new人气榜
  'groupstateget': '/wechat-service/matchLive/getThumbsUpStateByMatchID/',//根据赛事编号判断该赛事是否可以点赞(0：不可用，1：可用)，即是否所有组别是否结束
  'thumbsupget': '/wechat-service/matchLive/getThumbsUpList',//获取点赞列表
  'thumbsupset': '/wechat-service/matchLive/thumbsUpToPlayer',//给选手点赞
  /*成绩查询*/
  'scorelisturl': '/wechat-service/achievementController/getAchievement',//赛事成绩查询(成绩正式发布后)
  'realscorelisturl': '/wechat-service/matchLive/getRealTimeAchievement',//赛事成绩查询{matchGroupID}(实时查询)
  'claimscoreurl': '/wechat-service/achievementController/claimAchievement',//赛事成绩认领
  'scorematchlisturl': '/wechat-service/achievementController/getMatchListForAchievement',//获取成绩查询赛事列表
  //new 证书
  'playersearch': '/wechat-service/achievementController/getPlayerInfoByPlayerCode',//通过选手参赛号模糊搜索选手
  'certificateget': '/wechat-service/achievementController/getCompletionCertificateByPlayerCode',//获取完赛证书
  'playerinfourl': '/wechat-service/personalCenter/getPlayerMatchRankInfo',//证书-获取选手信息
  'checkinfoget': '/wechat-service/personalCenter/getPlayerCheckInfo',//获取选手打卡详情

  /*工作人员*/
  'workeraccess': '/wechat-service/workerCenter/workerLogin',//授权登录
  'matchliveurl': '/wechat-service/matchLive/getMatchLive',//获取赛事圈列表
  'sendmatchlive': '/wechat-service/workerCenter/sendMatchLive',//发布赛事圈
  'delmatchlive': '/wechat-service/workerCenter/delMatchLive',//发布赛事圈
  'workerscore': '/wechat-service/workerCenter/achievementManagement',//工作人员成绩管理
  'commentstate': '/wechat-service/workerCenter/getMatchCommentState',//获取赛事评论开关状态
  'commentstateset': '/wechat-service/workerCenter/changeMatchCommentState',//赛事评论开启/关闭
  'matchinfoget': '/wechat-service/workerCenter/getMatchImGroupID',//获取赛事IM编号
  /*微信分享*/
  'wechatticket': '/wechat-service/matchLive/getWeChatApiTicket',//JS-SDK使用权限签名获取
  /*押金收取*/
  'playerinfoget': '/wechat-service/payment/getPlayerInfoByCode',//根据赛事编号和选手参赛号获取选手信息
  'depositpay': '/wechat-service/payment/depositPayment',//押金支付
  /*赛事领物*/
  'assemcomme': '/wechat-service/assembleController/assembleComment',//获取领物说明
  'assemsearch': '/wechat-service/assembleController/player',//赛事检录选手搜素
  'assemdetail': '/wechat-service/assembleController/playerCheckInAssembleFlow',//获取选手详情和检录流程
  /*星跑押金支付接口*/
  'depositmatch': '/deposit/payment/matchInfo',//通过赛事ID查询赛事详情
  'depositplayer': '/deposit/payment/playerInfo',//通过选手参赛号或者身份证号码查询选手详情
  'depositplayerinfo': '/deposit/payment/getPlayerInfoByCode',//根据赛事编号和选手参赛号获取选手信息
  'depositpayment': '/deposit/payment/depositPayment',//押金支付
  'depositorder': '/deposit/deposit/depositOrders',//支付结果查询
}
let mapConfig = {
  token: 'pk.eyJ1IjoibGllcmlzbWUiLCJhIjoiY2lodmw4MWh1MDI2bnRnbTFxNmY3dDMxYyJ9.2hGe4xXi2Xsk_h_U6usr8w',
  style: {
    'version': 8,
    'name': 'RasterTiles',
    'sources': {
      'mapStyleLayer': {
        'type': 'raster',
        // 'tiles': ['//map.cmfun.cn:55555/googlemap-street-offset/vt/lyrs=y&hl=zh-CN&gl=CN&x={x}&y={y}&z={z}&s=Galileo&scale=2'],
        // 'tiles': ['http://map.orieange.com:55555/googlemap-satellite-HK/vt/lyrs=y&hl=zh-CN&gl=CN&x={x}&y={y}&z={z}&s=Galileo&scale=2'],
        // 'tiles': ['//map.orieange.com:55555/googlemap-street-offset/vt/lyrs=y&hl=zh-CN&gl=CN&x={x}&y={y}&z={z}&s=Galileo&scale=2'],
        // 'tiles': ['https://testmap.cmfun.cn/googlemap-street-offset/vt/lyrs=y&hl=zh-CN&gl=CN&x={x}&y={y}&z={z}&s=Galileo&scale=2'],
        'tiles': ['https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'],//Esri(WGS-84 地心坐标系)
        // 'tiles': ['http://t0.tianditu.gov.cn/img_c/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={x}&TILECOL={y}&tk=dd0cdf36a8779fb265bbfb9dd992ce56'],//天地图(WGS-84 地心坐标系)
        // 'tiles': ['http://t0.tianditu.com/vec_w/wmts?tk=e90d56e5a09d1767899ad45846b0cefd&SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=tiles'],//天地图(WGS-84 地心坐标系)
        // 'tiles': [
          // '//t0.tianditu.com/img_w/wmts?tk=2c916e54bf9909661dec72eb2b66592f&SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=tiles',
          // 'https://t0.tianditu.gov.cn/img_w/wmts?tk=2c916e54bf9909661dec72eb2b66592f&SERVICE=WMTS&REQUEST=GetTile&LAYER=img&TILEMATRIXSET=w&FORMAT=tiles&VERSION=1.0.0&STYLE=default&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}',
        // ],//天地图(WGS-84 地心坐标系)
        'tileSize': 256
      },
      'tdtCva ': {
        'type': 'raster',
        'tiles': [
          'https://t0.tianditu.gov.cn/cva_w/wmts?tk=2c916e54bf9909661dec72eb2b66592f&SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=tiles'
        ],
        'tileSize': 256
      }
    },
    'glyphs': 'mapbox://fonts/wzz/{fontstack}/{range}.pbf',
    'layers': [
      {
        'id': 'mapStyleLayer',
        'type': 'raster',
        'source': 'mapStyleLayer',
        'paint': {'raster-fade-duration': 100}
      },
      /*{
        'id': 'tdtCva',
        'type': 'raster',
        'source': 'tdtCva',
        'paint': {'raster-fade-duration': 100}
      }*/
    ]
  },
  tiles: {
    // 'tiles2': ['https://testmap.cmfun.cn/googlemap-street-offset/vt/lyrs=y&hl=zh-CN&gl=CN&x={x}&y={y}&z={z}&s=Galileo&scale=2'],//google地图(国内：GCJ-02 火星坐标系，国外：WGS-84 地心坐标系)
    // 'tiles2': ['//t0.tianditu.com/img_w/wmts?tk=e90d56e5a09d1767899ad45846b0cefd&SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=tiles'],//google地图(国内：GCJ-02 火星坐标系，国外：WGS-84 地心坐标系)
    'tiles2': ['https://t0.tianditu.gov.cn/img_w/wmts?tk=2c916e54bf9909661dec72eb2b66592f&SERVICE=WMTS&REQUEST=GetTile&LAYER=img&TILEMATRIXSET=w&FORMAT=tiles&VERSION=1.0.0&STYLE=default&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}'],//google地图(国内：GCJ-02 火星坐标系，国外：WGS-84 地心坐标系)
    'tiles1': ['https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'],//Esri(WGS-84 地心坐标系)
    'tiles3': ['//ak.dynamic.t0.tiles.virtualearth.net/comp/ch/{quadkey}?mkt=zh-cn&it=A,G,L,LA&shading=hill&og=56&n=z'],//bing(GCJ-02 火星坐标系)
    'tiles4': [
      '//wprd01.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&style=6',
      '//wprd02.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&style=6',
      '//wprd03.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&style=6',
      '//wprd04.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&style=6',
    ],//高德地图(GCJ-02 火星坐标系)
  },
  tstyle: {//天地图：CGCS2000坐标系，与WGS-84差别不大，cm水平坐标精度以上没差
    'version': 8,
    'sources': {
      'tdtImg': {
        'type': 'raster',
        'tiles': [],//'//t0.tianditu.gov.cn/img_w/wmts?tk=985c987051be0ae61af3afed0dbadff5&SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=tiles'
        'tileSize': 256
      },
      'tdtCia': {
        'type': 'raster',
        'tiles': [],//'//t0.tianditu.gov.cn/cia_w/wmts?tk=985c987051be0ae61af3afed0dbadff5&SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=tiles'
        'tileSize': 256
      }
    },
    'layers': [
      {'id': 'tdtImg', 'type': 'raster', 'source': 'tdtImg'},
      {'id': 'tdtCia', 'type': 'raster', 'source': 'tdtCia'}
    ],
    'glyphs': 'mapbox://fonts/wzz/{fontstack}/{range}.pbf',
  },
  coortype: 2 //1:GCJ-02、2:WGS-84
}
let setMapConfig = function () {
  // let token = '985c987051be0ae61af3afed0dbadff5'
  let token = 'ba649be87521d5732b41eb3be53ec81e'
  let tdtUrl = '//t{s}.tianditu.gov.cn/'
  let subdomains = ['0', '1', '2', '3', '4', '5', '6', '7']
  let imgUrls = [], ciaUrls = []
  for (let i = 0; i < subdomains.length; i++) {
    let imgurl = tdtUrl.replace('{s}', subdomains[i]) + 'DataServer?T=img_w&x={x}&y={y}&l={z}&tk=' + token;
    let ciaurl = tdtUrl.replace('{s}', subdomains[i]) + 'DataServer?T=cia_w&x={x}&y={y}&l={z}&tk=' + token;
    imgUrls.push(imgurl);
    ciaUrls.push(ciaurl);
  }
  mapConfig.tstyle.sources.tdtImg.tiles = imgUrls
  mapConfig.tstyle.sources.tdtCia.tiles = ciaUrls
}
setMapConfig()

let ossConfig = {
  // region: 'oss-cn-shanghai',
  // accessKeyId: 'LTAI4GC1HDeXtsHgkBJZ6pZX',
  // accessKeySecret: 'zBwXmhc1s0gQZfGOsLKs4MuRmFMmB9',
  // bucket: 'jgwl-resource'
  region: 'oss-cn-beijing',
  accessKeyId: 'LTAI5tPST8LJbAaH5cVZvyyM',
  accessKeySecret: 'gWGtpPYOlOrmSSAgSAvsc5x78XWcsM',
  bucket: 'utrail-oss'
}
export default {server, mapConfig, ossConfig}
